/**
 * Expects phone number with country code
 * @example isValidPhoneNr(31612345678)
 * @returns false if number with dutch country code that is != 11 digits
 */
export const isValidPhoneNr = (value: string | number): boolean => {
    if (!value) return false
    const isDutch: boolean = value.toString().startsWith('31')
    return isDutch ? value.toString().length === 11 : true
}
